import Card from 'components/Card'
import { CustomInput } from 'components/KodiakFarms/RewardSelector'
import Row from 'components/Row'
import { Loader } from 'react-feather'
import styled from 'styled-components'

import { StyledInputProps } from './types'

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderSecondary};
  padding-bottom: 1rem;
`

export const CardDescription = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.textSecondary};
`

export const CardContent = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
`

export const StatusText = styled.span`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.textSecondary};
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const InputLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
`

export const StyledInput = styled(CustomInput)<StyledInputProps>`
  width: 100%;
  padding: 0.625rem 1rem;
  border: 1px solid ${(props) => (props.hasError ? props.theme.error700 : props.theme.borderSecondary)};
  transition: all 0.2s;
`

// Status Indicator styles
export const StatusIndicator = styled.div<{ status: 'active' | 'not_started' }>`
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: ${(props) => (props.status === 'active' ? props.theme.success500 : props.theme.deprecated_yellow1)};
`

// Review Item styles
export const ReviewItemWrapper = styled(Card)`
  padding: 1rem;
  width: 100%;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &:hover {
    border-color: ${({ theme }) => theme.hoverDefault};
  }
`

export const ReviewItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const ReviewItemLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.textPrimary};
`

export const ModifiedBadge = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background: ${({ theme }) => theme.backgroundBackdrop};
  color: ${({ theme }) => theme.textSecondary};
  border-radius: 9999px;
  font-weight: 500;
`

export const Container = styled(Card)`
  width: 100%;
  max-width: 45rem;
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  background: ${({ theme }) => theme.cardPrimary};
  overflow: hidden;
`

export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.textSecondary};
`

export const StepDot = styled.div<{ active?: boolean }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${(props) => (props.active ? props.theme.accentActive : props.theme.deprecated_green1)};
`

export const FormGrid = styled.div`
  display: grid;
  gap: 1.5rem;
`

export const ReviewGrid = styled.div`
  display: grid;
  width: 100%;
  gap: 1rem;
`

export const InfoAlert = styled(Card)`
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  svg {
    color: ${({ theme }) => theme.textTertiary};
    flex-shrink: 0;
    margin-top: 0.125rem;
  }
`

export const InfoText = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.textSecondary};
`

export const LoaderIcon = styled(Loader)`
  animation: spin 1s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: ${({ theme }) => theme.error500};
  font-size: 0.875rem;
  margin-top: 0.25rem;

  svg {
    flex-shrink: 0;
  }
`

export const ReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ReviewValue = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.textPrimary};
  line-height: 1.5;
`

export const SubText = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
`

export const PreviousValue = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.textSecondary};
  display: flex;
  align-items: center;
  gap: 0.375rem;
`
export const RedeemDateSelectorWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 8px;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  outline: none;
  border-radius: 6px;
  border-style: solid;
  -webkit-appearance: none;

  ::placeholder {
    color: ##64748b;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  transition: border 100ms;
`

export const ErrorText = styled.pre`
  font-size: 0.675rem;
  margin: 0px;

  color: ${({ theme }) => theme.error500};
`
export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  padding: 8px;
`

export const SliderValueDisplay = styled.div`
  text-align: right;
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.textSecondary};
`

export const ErrorMessageBox = styled.div`
  margin: 1rem 0;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.error500};
  border-radius: 12px;
  background-color: rgba(220, 30, 30, 0.05);
`

export const ErrorHeader = styled(Row)`
  align-items: center;
  margin-bottom: 12px;
` as React.ComponentType<any>

export const ErrorActions = styled(Row)`
  margin-top: 12px;
  gap: 12px;
` as React.ComponentType<any>
